<template>
  <!-- <div class="bk-container bk-personal_center clearfix"> -->
    <div>
      <div class="left-wrapper">
        <div class="app-detail">
          <router-link to="/s-mart/personal_center/works/" class="app-link">
            <i class="icon-upper"></i>
          </router-link>
          <div class="app">
            <div class="app-img">
              <img :src="appLogo" alt="">
            </div>
            <span>{{userName}}</span>
          </div>
        </div>
        <ul class="account-list list-box">
          <li>
            <router-link to="detail" exact>作品概况</router-link>
          </li>
          <li>
            <router-link to="basic_information">基础资料</router-link>
          </li>
          <li>
            <router-link to="works_pictures">作品图片</router-link>
          </li>
          <li>
            <router-link to="version_file">版本文件</router-link>
          </li>
          <li>
            <router-link to="work_information">作品资料</router-link>
          </li>
          <li>
            <router-link to="trading_mode">交易模式</router-link>
          </li>
          <li>
            <router-link to="collect_user">收藏用户</router-link>
          </li>
          <li>
            <router-link to="download_user">下载用户</router-link>
          </li>
        </ul>
      </div>
      <div class="right-wrapper">
        <router-view :appLogo.sync = "appLogo"></router-view>
      </div>
    </div>
  <!-- </div> -->
</template>

<script  type="text/javascript">
   export default {
    data() {
      return {
      appLogo: '',
      userName: ''
      }
    },
    methods: {
     getBasicInfo () {
      const app_id = this.$route.params.wid;
       
        axios.get(myUrl + `core/product/info/${app_id}/`, {
          params: {
            keyword: 'basic'
          }
        }).then((res) => {
          this.userName = res.data.data.app_name;
          this.appLogo = res.data.data.app_logo;
        })
     }
    },
    created() {
      this.getBasicInfo();
    }
  }
</script>
<style media="screen" lang="scss">
  .app-detail {
    width: 100%;
    height: 60px;
    background: #fff;
    /* border-bottom: solid 10px #f4f4f4; */
    margin-bottom: 10px;
    .app-link {
      display: inline-block;
      width: 27px;
      height: 60px;
      text-align: center;
      border-right: solid 1px #f4f4f4;
    }
    .icon-upper {
      width: 6px;
      height: 10px;
      display: inline-block;
      background: url(../../images/common/upper.png) no-repeat;
      margin: 25px 0;
    }
    .app {
      padding: 11px 8px;
      width: 221px;
      float: right;
      height: 60px;
      span {
        line-height: 38px;
        max-width: 157px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        padding-left: 10px;
        font-size: 16px;
        color: #a6a6a6;
      }
      .app-img {
        width: 38px;
        height: 38px;
        display: inline-block;
        float: left;
        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
      }
    }
  }
  .bk-personal_center .left-wrapper .list-box li{
      height: auto !important;
  }
  .content-none{
    /*display:none;*/
    margin: 135px 0;
    text-align: center;
    p{
      margin-top: 25px;
      font-size: 16px;
      color: #878996;
      a{
        color: #57a3f1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// works_detail.vue?086e2ed0